<template>
    <Card :title="title">
      <div class="mb-4">
        <label for="month-select" class="block text-sm font-medium text-gray-700 mb-1">Select Month</label>
        <input
          id="month-select"
          type="month"
          v-model="selectedMonth"
          class="border border-gray-300 rounded px-3 py-2 w-full max-w-xs"
          @change="fetchSummary"
        />
      </div>

      <div v-if="loading" class="text-gray-500">Loading ZenDesk Summary...</div>
      <div v-else>
        <p class="mb-4 text-gray-700">
          <span v-if="summary.length">
            {{ summary.length }} contracts summarized. Most tickets:
            {{ summary.reduce((max, row) => row.total > max.total ? row : max, summary[0]).contract }}.
          </span>
          <span v-else>No summary data found for this month.</span>
        </p>

        <ul class="mb-4 text-sm text-gray-800 list-disc list-inside">
          <li>Total Tickets: {{ summaryStats.total }}</li>
          <li>New: {{ summaryStats.new }}</li>
          <li>Open: {{ summaryStats.open }}</li>
          <li>Pending: {{ summaryStats.pending }}</li>
          <li>Hold: {{ summaryStats.hold }}</li>
          <li>Solved: {{ summaryStats.solved }}</li>
          <li>Closed: {{ summaryStats.closed }}</li>
        </ul>

        <router-link
          :to="`/${id}/ZendeskSummary`"
          class="inline-flex items-center px-5 py-3 bg-white text-indigo-600 font-semibold border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 transition duration-200"
        >
          View Detailed Zendesk Reports
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ml-2 h-4 w-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </router-link>
      </div>
    </Card>
  </template>

<script>
import Card from '../Card.vue'
import HTTP from '@/common/http'

export default {
  name: 'ZendeskSummaryCard',
  components: { Card },
  props: {
    id: {
      type: String,
      required: true
    },
    activeType: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: 'Zendesk Summary'
    }
  },
  data () {
    const now = new Date()
    const defaultMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
    return {
      summary: [],
      loading: false,
      selectedMonth: defaultMonth
    }
  },
  computed: {
    summaryStats () {
      return this.summary.reduce(
        (acc, row) => {
          acc.total += row.total || 0
          acc.new += row.new || 0
          acc.open += row.open || 0
          acc.pending += row.pending || 0
          acc.hold += row.hold || 0
          acc.solved += row.solved || 0
          acc.closed += row.closed || 0
          return acc
        },
        {
          total: 0,
          new: 0,
          open: 0,
          pending: 0,
          hold: 0,
          solved: 0,
          closed: 0
        }
      )
    }
  },
  mounted () {
    this.fetchSummary()
  },
  methods: {
    fetchSummary () {
      if (!this.id || !this.activeType) return

      const delay = setTimeout(() => {
        this.loading = true
      }, 150)

      HTTP.get(`zendesk/summary/${this.activeType}/${this.id}/${this.selectedMonth}`)
        .then(response => {
          this.summary = response.data.summary || []
        })
        .catch(error => {
          console.error('Error fetching summary:', error)
          this.$flashMessage.error({ message: `Failed to load summary: ${error.message}` })
        })
        .finally(() => {
          clearTimeout(delay)
          this.loading = false
        })
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/Cards/InfoCards/ZendeskSummaryCard.vue